const Sdata = {
    shopItems: [
      {
        id: 7,
        cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/shops/shops-1.png",
        name: "Mapple Earphones",
        price: "180",
        discount: "25",
      },
      {
        id: 8,
        cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/shops/shops-2.png",
        name: "Vivo android one",
        price: "120",
        discount: "10",
      },
      {
        id: 9,
        cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/shops/shops-3.png",
        name: "Sony Light",
        price: "20",
        discount: "50 ",
      },
      {
        id: 10,
        cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/shops/shops-4.png",
        name: "Iphone",
        price: "999",
        discount: "10 ",
      },
      {
        id: 11,
        cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/shops/shops-5.png",
        name: "Ceats wireless earphone",
        price: "80",
        discount: "20 ",
      },
      {
        id: 12,
        cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/shops/shops-7.png",
        name: "Redimi Phone",
        price: "400",
        discount: "20 ",
      },
      {
        id: 13,
        cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/shops/shops-8.png",
        name: "Xeats Bluetooth earphones",
        price: "60",
        discount: "5 ",
      },
      {
        id: 14,
        cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/shops/shops-9.png",
        name: "Airpod",
        price: "120",
        discount: "10",
      },
      {
        id: 15,
        cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/shops/shops-10.png",
        name: "Silver Cap",
        price: "5",
        discount: "2",
      },
      {
        id: 16,
        cover: "https://m.media-amazon.com/images/I/51rzz4zoUBL._SX300_SY300_QL70_FMwebp_.jpg",
        name: "Laptop Bag",
        price: "16",
        discount: "7",
      },
      {
        id: 17,
        cover: "https://m.media-amazon.com/images/I/81V5P1x+LSL._AC_UY327_FMwebp_QL65_.jpg",
        name: "Gaming Laptop",
        price: "200",
        discount: "50",
      },
      {
        id: 18,
        cover: "https://m.media-amazon.com/images/I/51SzLWO7e+L._SY300_SX300_.jpg",
        name: "Mouse Pad",
        price: "20",
        discount: "4",
      },
    ],
  }
  export default Sdata